import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {IAppDispatch} from "../../store/store";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {getRecommendedProperties} from "../api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../hooks/use_recommended_properties_payload";

export const fetchRecommendedPropertiesAtRoute = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const property = getState().property.property;
    const maxPrice = getState().user.preferences?.data?.filters?.price_1 || property?.price?.toString();
    const payload = property && useRecommendedPropertiesPayload({property, filters: {maxPrice}});
    const recommendedPropertiesList = payload && (await dispatch(getRecommendedProperties.endpoints.getRecommendedProperties.initiate(payload)));

    if (
        (recommendedPropertiesList?.isError && isRtkqError(recommendedPropertiesList.error) && recommendedPropertiesList.error.status === 404) ||
        !recommendedPropertiesList?.data
    ) {
        return true;
    }
};
import {IFetchContext} from "@pg-mono/data-fetcher";

import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {IAppDispatch} from "../../store/store";
import {isRtkqError} from "../../store/utils/is_rtkq_error";
import {getRecommendedProperties} from "../api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../hooks/use_recommended_properties_payload";

export const fetchRecommendedPropertiesAtRoute = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch, getState: () => IRPStore) => {
    const property = getState().property.property;
    const maxPrice = getState().user.preferences?.data?.filters?.price_1 || property?.price?.toString();
    const payload = property && useRecommendedPropertiesPayload({property, filters: {maxPrice}});
    const recommendedPropertiesList = payload && (await dispatch(getRecommendedProperties.endpoints.getRecommendedProperties.initiate(payload)));

    if (
        (recommendedPropertiesList?.isError && isRtkqError(recommendedPropertiesList.error) && recommendedPropertiesList.error.status === 404) ||
        !recommendedPropertiesList?.data
    ) {
        return true;
    }
};
